import { Button as MUIButton, ButtonProps } from '@mui/material';

interface IProps extends ButtonProps {
  to?: string;
}

export function Button({ children, ...rest }: IProps) {
  return <MUIButton {...rest}>{children}</MUIButton>;
}
